/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { OnboardingStepDTO } from './OnboardingStepDTO';

export type OnboardingStepResponseDTO = {
    currentStatus?: OnboardingStepResponseDTO.currentStatus;
    phoneNumber?: string;
    registrationType?: OnboardingStepResponseDTO.registrationType;
    steps?: Array<OnboardingStepDTO>;
};

export namespace OnboardingStepResponseDTO {

    export enum currentStatus {
        OTP_REQUEST_PAGE = 'OTP_REQUEST_PAGE',
        OTP_RESEND_PAGE = 'OTP_RESEND_PAGE',
        OTP_SUCCESS_PAGE = 'OTP_SUCCESS_PAGE',
        PENDING_TRANSACTION_PIN = 'PENDING_TRANSACTION_PIN',
        PENDING_LOGIN_PIN = 'PENDING_LOGIN_PIN',
        PENDING_REQUEST_OTP = 'PENDING_REQUEST_OTP',
        PENDING_VERIFY_OTP = 'PENDING_VERIFY_OTP',
        PENDING_REGISTRATION_TYPE = 'PENDING_REGISTRATION_TYPE',
        PENDING_SET_ACCOUNT = 'PENDING_SET_ACCOUNT',
        PENDING_PERSONAL_DETAILS = 'PENDING_PERSONAL_DETAILS',
        PENDING_SELFIE_VERIFICATION = 'PENDING_SELFIE_VERIFICATION',
        PENDING_BUSINESS_INFORMATION = 'PENDING_BUSINESS_INFORMATION',
        PENDING_CONFIRM_SEND_OTP = 'PENDING_CONFIRM_SEND_OTP',
        PENDING_CONFIRM_VERIFY_OTP = 'PENDING_CONFIRM_VERIFY_OTP',
        PENDING_CREATE_ACCOUNT = 'PENDING_CREATE_ACCOUNT',
        ACCOUNT_CREATED = 'ACCOUNT_CREATED',
        PENDING_REQUIRED_DOCUMENTS = 'PENDING_REQUIRED_DOCUMENTS',
        PENDING_PAYOUT_ACCOUNTS = 'PENDING_PAYOUT_ACCOUNTS',
        PENDING_PEOPLE = 'PENDING_PEOPLE',
        PENDING_SUBMIT = 'PENDING_SUBMIT',
        PENDING_REVIEW = 'PENDING_REVIEW',
        PENDING_DOCUMENTS = 'PENDING_DOCUMENTS',
        COMPLETED = 'COMPLETED',
    }

    export enum registrationType {
        INDIVIDUAL = 'INDIVIDUAL',
        SOLE_PROPRIETORSHIP = 'SOLE_PROPRIETORSHIP',
        LIMITED_LIABILITY = 'LIMITED_LIABILITY',
        NGO_NPO = 'NGO_NPO',
        GOVERNMENT = 'GOVERNMENT',
        PARTNERSHIP_INCORPORATED_TRUSTEES = 'PARTNERSHIP_INCORPORATED_TRUSTEES',
        CLUBS_SOCIETIES_ASSOCIATIONS = 'CLUBS_SOCIETIES_ASSOCIATIONS',
        COOPERATIVE_SOCIETIES = 'COOPERATIVE_SOCIETIES',
    }


}
